import React, { useEffect, useState } from "react";
import { itx, noItx } from "../translationItx/itx";

let lastOfflineStatus: boolean | undefined;

export function showOfflineStatus(offline: boolean) {
  if (lastOfflineStatus !== offline) {
    const event = new CustomEvent(noItx("showOfflineStatus"), { detail: { offline: offline } });
    document.dispatchEvent(event);
  }
  lastOfflineStatus = offline;
}

export default function OfflineStatus() {
  const [isOffline, setIsOffline] = useState(false);

  function handleOfflineStatus(ev: any) {
    setIsOffline(ev.detail.offline);
  }

  useEffect(() => {
    document.addEventListener("showOfflineStatus", handleOfflineStatus);
    return () => {
      document.removeEventListener("showOfflineStatus", handleOfflineStatus);
    };
  }, []);

  if (!isOffline) {
    return null;
  }

  return (
    <div
      id="offLineStatus"
      className="menuButton"
      style={{
        position: "relative",
        margin: "7px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        id="offLineStatus"
        className="menuButton"
        style={{
          position: "relative",

          width: "20px",
          height: "20px",
          backgroundColor: "var(--error-color)",
          padding: "4px",
          borderRadius: "20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <i
          className={"la la-chain-broken"} // no itx
        ></i>
      </div>

      <div style={{ paddingTop: "2px" }}>{itx("etsSyncAndExport.offline", "Offline")}</div>
    </div>
  );
}
